import React from 'react';

export const AddToWishlistContext = React.createContext({
    wishList: null,
    itemCount: null,
    addToWishlist: null,
    removeFromWishlist: null,
    pricePrefix: null,
    colors: null,
    buttonFields: null
})